import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Space } from 'antd';
import { formatNumber } from 'utils/numberFormat';
import Currency from 'components/Currency';
import { packageIdLabel, durationLabel } from '../catalogAdapter';

export interface PackageTimePanelProps {
  orderType: Pay.OrderType;
  curWorkingPackage: Pay.OrderedPackage;
  data: Pay.CalculatePackagePriceRst;
  currency: General.Currency;
  checkedPackageId?: Pay.PackageId;
  /** 目标套餐展示名（目录 displayName）；目录序号 id 会与老 套餐.* 词条冲突，优先用显式名称 */
  checkedPackageLabel?: string;
  durationNum: Pay.DurationNum;
}

// 升级/续订套餐的信息
export const PackageTimePanel = (props: PackageTimePanelProps) => {
  const {
    orderType,
    curWorkingPackage,
    data,
    currency,
    checkedPackageId,
    checkedPackageLabel,
    durationNum,
  } = props;

  const {
    beforeValidStart,
    beforeValidEnd,
    upgradePrice,
    increaseDurationPrice,
    afterValidStart,
    afterValidEnd,
  } = data;

  const { t } = useTranslate();

  return (
    <Container direction="vertical" size={4}>
      <div>
        <Label>
          {orderType === 'UPGRADE' ? t('market.升级前') : t('market.续订前')}(
          {packageIdLabel(
            curWorkingPackage.id,
            t,
            curWorkingPackage.comboName,
            curWorkingPackage.regionPackageId,
          )}
          ){t('market.有效期')}
        </Label>
        <span>
          {beforeValidStart}-{beforeValidEnd}
        </span>
      </div>

      {checkedPackageId ? (
        <div>
          <Label>
            {orderType === 'UPGRADE' ? t('market.升级后') : t('market.续订后')}(
            {checkedPackageLabel || t(`套餐.${checkedPackageId}`)}){t('market.有效期')}
          </Label>
          <span>
            {afterValidStart}-{afterValidEnd}
            {orderType === 'UPGRADE' && beforeValidEnd !== afterValidEnd ? (
              <UpgradeAddTimeTip>
                {t('market.时长增加多少', { s: durationLabel(durationNum, t) })}
              </UpgradeAddTimeTip>
            ) : null}
          </span>
        </div>
      ) : null}

      {orderType === 'UPGRADE' ? (
        <>
          <div>
            <Label>{t('market.升级套餐')}</Label>
            <span>
              {formatNumber(upgradePrice, '0,0.00')}
              <Currency value={currency} />
            </span>
          </div>
          <div>
            <Label>{t('market.增加时长')}</Label>
            <span>
              {formatNumber(increaseDurationPrice, '0,0.00')}
              <Currency value={currency} />
            </span>
          </div>
        </>
      ) : null}
    </Container>
  );
};

const Container = styled(Space)`
  color: var(--fett-text-tertiary);
`;

const Label = styled.span`
  &:after {
    content: ':';
    margin-right: 4px;
  }
`;

const UpgradeAddTimeTip = styled.span`
  margin-left: 8px;
  font-size: 12px;
  color: var(--fett-scenario-accent-text);
  background: #d7e1fa;
  padding: 0 4px;
  border-radius: 2px;
`;
